import React, { useState, useEffect } from 'react';
import Image from '../../components/AppImage';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import { useDispatch } from 'react-redux';
import { getAllProductsService, toggleFavService } from 'redux/services/general_service';
import Skeleton from 'react-loading-skeleton'; // استيراد Skeleton
import Link from '../../components/ui/Link';

const DiscountedProducts = () => {
  const { t, i18n } = useTranslation(); // Initialize translation
  const dispatch = useDispatch();
  const [discountProducts, setDiscountProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // حالة التحميل

  useEffect(() => {
    setIsLoading(true); // تعيين حالة التحميل إلى true
    dispatch(getAllProductsService({ has_discount: 1 })).then((response) => {
      if (response?.payload?.status == 200) {
        setDiscountProducts(response?.payload?.data?.data);
      }
      setIsLoading(false); // تعيين حالة التحميل إلى false بعد الانتهاء
    });
  }, []);

  const handleProductClick = (productId) => {
    window.location.href = `/product-detail?id=${productId}`;
  };

  const handleAddToCart = (e, product) => {
    e.stopPropagation();

    const existingCart = JSON.parse(localStorage.getItem('cartItems') || '[]');
    const existingCartCount = parseInt(localStorage.getItem('cartCount') || '0');

    const existingItemIndex = existingCart.findIndex((item) => item.id === product.id);

    if (existingItemIndex > -1) {
      existingCart[existingItemIndex].quantity += 1;
    } else {
      existingCart.push({
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image,
        quantity: 1,
        variant: 'Default',
      });
    }

    const newCartCount = existingCart.reduce((total, item) => total + item.quantity, 0);
    localStorage.setItem('cartItems', JSON.stringify(existingCart));
    localStorage.setItem('cartCount', newCartCount.toString());

    window.dispatchEvent(
      new CustomEvent('cartUpdated', {
        detail: { count: newCartCount, items: existingCart },
      })
    );
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat(i18n.language === 'en' ? 'en' : 'ar', {
      style: 'currency',
      currency: 'IQD',
    }).format(price);
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<Icon key={i} name="Star" size={12} className="text-yellow-400 fill-current" />);
    }

    if (hasHalfStar) {
      stars.push(
        <Icon key="half" name="StarHalf" size={12} className="text-yellow-400 fill-current" />
      );
    }

    const remainingStars = 5 - Math.ceil(rating);
    for (let i = 0; i < remainingStars; i++) {
      stars.push(<Icon key={`empty-${i}`} name="Star" size={12} className="text-gray-300" />);
    }

    return stars;
  };

  const onToggleSelection = (e, id) => {
    e.stopPropagation();
    dispatch(toggleFavService({ product_id: id })).then((response) => {
      if (response.payload.status == 200) {
        window.location.reload();
      }
    });
  };

  return (
    <section className="w-full py-8 lg:py-16">
      <div className="w-full max-w-[1262px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8 lg:mb-10">
          <h2 className="text-2xl lg:text-4xl font-medium text-black">{t('title')}</h2>
          <Link
            href="/product-listing?discounted=true"
            className="text-xs lg:text-base font-medium text-[#ca0d2d] hover:underline"
            variant="link"
            size="small"
            target="_self"
            rel=""
            onClick={() => {}}
            aria-label="View all flash sales"
          >
            {t('viewAllDeals')}
          </Link>
        </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-5">
          {isLoading ? (
            // عرض Skeleton Loader أثناء التحميل
            <>
              {Array.from({ length: 5 }).map((_, index) => (
                <div
                  key={index}
                  className="bg-surface border border-border rounded-lg overflow-hidden hover:shadow-interactive transition-smooth cursor-pointer group relative"
                >
                  <Skeleton height={200} />
                  <div className="p-3">
                    <Skeleton height={20} count={2} />
                  </div>
                </div>
              ))}
            </>
          ) : (
            discountProducts?.slice(0, 5)?.map((product) => {
             return (     <div
              key={product?.id}
               onClick={() => handleProductClick(product?.id)}
              className="relative bg-white rounded-lg shadow-[0px_0px_12px_#00000019] overflow-hidden hover:shadow-lg transition-shadow"
            >
            
               
                  {/* Discount Badge */}

                  <div className="absolute top-2 left-2 z-10 text-white text-xs px-2 py-1 rounded-full font-bold">
                    <span className="text-xs font-semibold text-white bg-[#ca0d2d] px-1 py-1 rounded-sm">
                      %{' '}
                      {(
                        ((product.price - product.price_after_discount) / product.price) *
                        100
                      ).toFixed(0)}{' '}
                      -
                    </span>
                  </div>

                  <div className="relative h-40 sm:h-48 overflow-hidden">
                    <Image
                      src={product?.images[0]?.file_path}
                      alt={product?.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />

                    {/* Savings Amount */}
                    <div className="absolute bottom-2 left-2 bg-black/70 text-white text-xs px-2 py-1 rounded-full">
                      {t('saveAmount', {
                        amount: formatPrice(product?.price - product?.price_after_discount),
                      })}
                    </div>

                    {/* Quick Actions */}
                    <div className="absolute bottom-2 right-2 transition-smooth">
                      <div className="flex space-x-1">
                        <button
                          onClick={(e) => onToggleSelection(e, product.id)}
                          className="w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center transition-smooth"
                        >
                          {product.in_favorite ? (
                            <Icon name="Heart" size={14} className="text-red-500 fill-current" />
                          ) : (
                            <Icon name="Heart" size={14} className="text-gray-500" />
                          )}
                        </button>
                        <button className="w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center transition-smooth">
                          <Icon name="Eye" size={14} />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="p-3">
                    <div className="mb-2">
                      <span className="text-xs text-text-secondary uppercase tracking-wide">
                        {product?.category?.translations?.ar?.name}
                      </span>
                    </div>

                    <h4 className="font-semibold text-global-text2 mb-[2px] line-clamp-2 group-hover:text-primary transition-smooth">
                      {product?.name}
                    </h4>

                    {/* Rating */}
                    <div className="flex items-center space-x-1 mb-2">
                      <div className="flex space-x-1">{renderStars(product?.rate)}</div>
                    </div>

                    {/* Price */}
                    <div className="flex items-center space-x-2 mb-2">
                      <span className="text-base font-semibold font-semibold text-[#ca0d2d]">
                        {formatPrice(product?.price_after_discount)}
                      </span>
                      <span className="text-sm text-text-secondary line-through text-sm font-semibold text-[#ca0d2d]">
                        {formatPrice(product?.price)}
                      </span>
                    </div>

                    {/* Add to Cart Button */}
                    <button
                  //    variant="default"
                    //  size="sm"
                     fullWidth
                      onClick={(e) => handleAddToCart(e, product)}
                    
                      className="text-white bg-[#ca0d2d] px-1 py-1 rounded-sm w-full"
                   
                    >
                      {t('addToCart')}
                    </button>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </section>
  );
};

export default DiscountedProducts;
